import React, { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Credits from './components/Credits';
import SubTrailer from './components/SubTrailer';
import Footer from './components/Footer';
import VideoModal from './components/VideoModal';
import { copy, Language } from './content/i18n';

function App() {
  const [modalUrl, setModalUrl] = useState<string | null>(null);
  const [language, setLanguage] = useState<Language>('en');
  const t = copy[language];

  return (
    <div style={{ background: '#080808', minHeight: '100vh', overflowX: 'hidden' }}>
      <div
        aria-label={t.app.languageSwitchLabel}
        style={{
          position: 'fixed',
          top: 18,
          right: 20,
          zIndex: 60,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: 4,
          border: '1px solid rgba(196,148,40,0.4)',
          background: 'rgba(5,5,5,0.6)',
          backdropFilter: 'blur(8px)',
          boxShadow: '0 10px 28px rgba(0,0,0,0.35)',
        }}
      >
        <button
          onClick={() => setLanguage('en')}
          aria-pressed={language === 'en'}
          style={{
            border: 'none',
            background: language === 'en' ? 'rgba(196,148,40,0.22)' : 'transparent',
            color: language === 'en' ? '#f6efe5' : 'rgba(255,255,255,0.72)',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '0.52rem',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            fontWeight: 600,
            padding: '8px 10px',
            cursor: 'pointer',
            transition: 'all 0.25s ease',
          }}
        >
          {t.app.languageEnglish}
        </button>
        <button
          onClick={() => setLanguage('ja')}
          aria-pressed={language === 'ja'}
          style={{
            border: 'none',
            background: language === 'ja' ? 'rgba(196,148,40,0.22)' : 'transparent',
            color: language === 'ja' ? '#f6efe5' : 'rgba(255,255,255,0.72)',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '0.52rem',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            fontWeight: 600,
            padding: '8px 10px',
            cursor: 'pointer',
            transition: 'all 0.25s ease',
          }}
        >
          {t.app.languageJapanese}
        </button>
      </div>

      {/* Skip to main content for accessibility */}
      <a
        href="#story"
        className="skip-link"
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        {t.app.skipToContent}
      </a>

      <main>
        <Hero
          language={language}
          onWatchTrailer={() => setModalUrl('https://player.vimeo.com/video/1148387564?h=d633bd12b4&autoplay=1')}
        />
        <About language={language} />
        <SubTrailer
          language={language}
          onPlay={() => setModalUrl('https://player.vimeo.com/video/1145094506?h=c9918384a4&autoplay=1')}
        />
        <Credits language={language} />
        {/* <Gallery /> */}
      </main>

      <Footer language={language} />

      <VideoModal
        language={language}
        url={modalUrl ?? ''}
        isOpen={!!modalUrl}
        onClose={() => setModalUrl(null)}
      />
    </div>
  );
}

export default App;
